import type { NskResponse } from "~/models/Api";
import { generatePath } from "~/utils/generatePath";
import { postRequest, putRequest } from "../api_handler";

export const create = async (vendorUserId: number): Promise<NskResponse> =>
	postRequest(generatePath("/vendors/vendor_user_password_resets"), {
		vendorUserId
	});

export const update = async (
	token: string,
	password: string
): Promise<NskResponse> =>
	putRequest(generatePath("/vendors/vendor_user_password_resets"), {
		password,
		token
	});
